import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function HomeIcon({
	width = 21,
	height = 21,
	color = 'currentColor',
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 21 21"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<path
				d="M10.5003 0.5L0.5 7.99988V20.5H7.25003V12.0001H13.75V20.5H20.5V7.99988L10.5003 0.5Z"
				fill={color}
				stroke={color}
				strokeLinejoin="round"
			/>
		</svg>
	);
}
